import { connect } from 'react-redux';
import { StoreState } from '../../../reducers';
import UprezShareForm from '../../../components/Share/UprezForm';
import DriveItemUtils from '../../../utils/driveItem';
import RoutesUtils from '../../../utils/routes';
import { RoutePath } from '../../../routes/constants';
import { Api } from '../../../typings/api';
import { StyleColor } from '../../../utils/styles-constants';

const mapStateToProps = (state: StoreState) => {
	const { sharePanel, routerParamsHistory } = state;
	const { form, isOpen, isProcessing, selection, foldersContent } = sharePanel;
	const isCreateDealAvailable = [...selection, ...foldersContent].some(item => (
		DriveItemUtils.isProposal(item.format as Api.PublicationFormat))
	);
	const currentRoute = RoutesUtils.getCurrentRoute(routerParamsHistory);
	const isEditorOpened = currentRoute.includes(RoutePath.Editor);

	return {
		form,
		isOpen,
		isProcessing,
		isCreateDealAvailable,
		actionButtonColor: isEditorOpened ? StyleColor.Blue600 : '',
	};
};

export default connect(mapStateToProps)(UprezShareForm);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Share/UprezForm/index.tsx